import { render, staticRenderFns } from "./SimpleRow.vue?vue&type=template&id=54dc0d3a&"
import script from "./SimpleRow.vue?vue&type=script&lang=ts&"
export * from "./SimpleRow.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports